<!-- Icona compatta con badge: apre la nuvoletta dei download -->
<button type="button" class="notification-bell" (click)="op.toggle($event)" [title]="'export_jobs.title' | translate">
  <i class="pi pi-cloud-download" style="font-size: 1.2rem; color: var(--kcs-topnav-text, var(--kcs-header-text));"></i>
  @if (exportJobs.attentionCount() > 0) {
  <span class="notification-badge">{{ exportJobs.attentionCount() > 99 ? '99+' : exportJobs.attentionCount() }}</span>
  }
</button>

<p-popover #op>
  <div class="export-jobs-popover" style="width: 340px; max-width: 92vw">
    <!-- intestazione: titolo + contatore + svuota completati -->
    <div class="d-flex align-items-center justify-content-between mb-2" style="gap: 8px">
      <h6 class="titolo-card mb-0" style="font-size: 14px; white-space: nowrap">
        <i class="pi pi-download me-1" aria-hidden="true"></i>{{ 'export_jobs.title' | translate }}@if (jobs.length) {
        <span
          style="color: var(--kcs-secondary-text, #888); font-weight: 400"
          >
          ({{ jobs.length }})</span
          >
        }
      </h6>
      @if (exportJobs.completedCount() > 0) {
        <a
          (click)="exportJobs.removeCompleted()"
          style="cursor: pointer; font-size: 11px; white-space: nowrap; color: var(--kcs-secondary-text, #888)"
          >
          <i class="pi pi-trash" aria-hidden="true"></i> {{ 'export_jobs.clear_completed' | translate }}
        </a>
      }
    </div>

    @if (jobs.length === 0) {
      <div class="kcs-form-label py-2">{{ 'export_jobs.empty' | translate }}</div>
    }

    <!-- lista scrollabile: altezza limitata per non sforare lo schermo -->
    <div style="max-height: 50vh; overflow-y: auto; overflow-x: hidden">
      @for (job of jobs; track job) {
        <div
          class="d-flex align-items-center justify-content-between gap-2 py-1"
          style="border-top: 1px solid var(--kcs-border, #eee)"
          >
          <div class="flex-grow-1" style="min-width: 0">
            <div class="text-truncate" style="font-size: 12px">{{ job.exj_label }}</div>
            <p-tag
              [severity]="severity(job.exj_stato)"
              [value]="'export_jobs.stato_' + job.exj_stato | translate"
              class="mt-1"
            ></p-tag>
          </div>
          <div class="d-flex gap-1" style="flex-shrink: 0">
            <button
              pButton iconOnly
              type="button"
             
              class="p-button-secondary p-button-sm"
              pTooltip="{{ 'export_jobs.info' | translate }}"
              (click)="openSummary(job)"
            ><i class="p-button-icon pi pi-info-circle"></i></button>
            @if (job.exj_stato === 'DONE') {
              <button
                pButton iconOnly
                type="button"
               
                class="p-button-success p-button-sm"
                pTooltip="{{ 'export_jobs.download' | translate }}"
                (click)="exportJobs.download(job)"
              ><i class="p-button-icon pi pi-download"></i></button>
            }
            <button
              pButton iconOnly
              type="button"
             
              class="p-button-danger p-button-sm"
              pTooltip="{{ 'export_jobs.delete' | translate }}"
              (click)="exportJobs.remove(job)"
            ><i class="p-button-icon pi pi-trash"></i></button>
          </div>
        </div>
      }
    </div>
  </div>
</p-popover>

<!-- Modale resoconto del download -->
<p-dialog
  [(visible)]="showSummary"
  [modal]="true"
  [draggable]="false"
  [style]="{ width: '480px', maxWidth: '95vw' }"
  header="{{ 'export_jobs.summary_title' | translate }}"
  >
  @if (summaryJob) {
    <div>
      <div class="mb-2" style="font-weight: 600">{{ summaryJob.exj_label }}</div>
      <div class="mb-2">
        <p-tag [severity]="severity(summaryJob.exj_stato)" [value]="'export_jobs.stato_' + summaryJob.exj_stato | translate"></p-tag>
      </div>
      @if (summaryJob.exj_error) {
        <div class="mb-2" style="color: var(--kcs-danger, #d9534f); font-size: 13px">
          {{ summaryJob.exj_error }}
        </div>
      }
      @if (summaryJob.exj_summary) {
        <pre
			style="
				white-space: pre-wrap;
				word-break: break-word;
				font-family: inherit;
				font-size: 13px;
				margin: 0;
				max-height: 50vh;
				overflow: auto;
			"
          >{{ summaryJob.exj_summary }}</pre
          >
        }
        @if (!summaryJob.exj_summary && !summaryJob.exj_error) {
          <div class="kcs-form-label">
            {{ 'export_jobs.no_detail' | translate }}
          </div>
        }
      </div>
    }
    <ng-template #footer>
      <p-button label="{{ 'button.chiudi' | translate }}" size="small" severity="secondary" [outlined]="true" (onClick)="showSummary = false"></p-button>
    </ng-template>
  </p-dialog>
